import React, { useState, useEffect } from 'react';

const COOKIE_KEY = 'cookieConsentAccepted';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);


  const acceptCookies = () => {
    localStorage.setItem(COOKIE_KEY, 'true');
    setVisible(false);
  };

  const rejectCookies = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      background: 'rgba(0,0,0,0.85)',
      color: '#fff',
      padding: '16px',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    }}>
      <span style={{ marginBottom: 8 }}>
        This site uses cookies to enhance your browsing experience. By continuing to use our site, you accept our use of cookies. See our Privacy Policy for more info.
      </span>
      <div style={{ display: 'flex', gap: 12 }}>
        <button
          onClick={acceptCookies}
          style={{
            background: '#2563eb',
            color: '#fff',
            border: 'none',
            borderRadius: 4,
            padding: '8px 20px',
            fontWeight: 'bold',
            cursor: 'pointer',
          }}
        >
          Accept
        </button>
        <button
          onClick={rejectCookies}
          style={{
            background: '#fff',
            color: '#222',
            border: '1px solid #ccc',
            borderRadius: 4,
            padding: '8px 20px',
            fontWeight: 'bold',
            cursor: 'pointer',
          }}
        >
          Reject
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
